export const GET_LIVE_CATEGORIES = "GET_LIVE_CATEGORIES";
export const GET_LIVE_CATEGORIES_SUCCESS = "GET_LIVE_CATEGORIES_SUCCESS";
export const GET_LIVE_CATEGORIES_FAILURE = "GET_LIVE_CATEGORIES_FAILURE";

export const GET_MOVIES_CATEGORIES = "GET_MOVIES_CATEGORIES";
export const GET_MOVIES_CATEGORIES_SUCCESS = "GET_MOVIES_CATEGORIES_SUCCESS";
export const GET_MOVIES_CATEGORIES_FAILURE = "GET_MOVIES_CATEGORIES_FAILURE";

export const GET_SERIES_CATEGORIES = "GET_SERIES_CATEGORIES";
export const GET_SERIES_CATEGORIES_SUCCESS = "GET_SERIES_CATEGORIES_SUCCESS";
export const GET_SERIES_CATEGORIES_FAILURE = "GET_SERIES_CATEGORIES_FAILURE";

export const ADD_PARENTAL_LOCK = "ADD_PARENTAL_LOCK";

export const EPG_TIME_SHIFT = 'EPG_TIME_SHIFT'

export const LOG_OUT = "LOG_OUT";